import { BaseQueryWithValidationClass } from 'src/editor/api/queries/utils/query-with-validation-class'
import { getWebsiteThemes } from 'src/editor/api/website-themes-api'
import { WebsiteThemesResponseInterface } from 'src/shared/types/website-settings-types'

class WebsiteThemesQueryClass extends BaseQueryWithValidationClass<
  [],
  WebsiteThemesResponseInterface
> {
  queryFn = getWebsiteThemes
  getQueryKey = () => ['websiteThemes'] as const
}

export const websiteThemesQuery = new WebsiteThemesQueryClass()
